import React from 'react';
import { withApollo, compose } from 'react-apollo';
import _ from 'lodash';

import { CreateCorrectedEmail } from '../../../mutations/CreateCorrectedEmail';
import TaskView from './TaskView';
import withClaimQuery from '../withClaimQuery';
import { CurrentClaim } from '../../../queries/CurrentClaim';

class ContactPaxRegardingInvalidEmailTask extends React.Component {
  state = {};

  handleEmailChange = (e, { value }) => this.setState({ newEmail: value });

  handleTaskUpdate = () => {
    const { newEmail } = this.state;
    const { task, client, onTaskComplete } = this.props;
    const { id, claimId } = task || '';
    this.setState({ loading: true });
    client
      .mutate({
        mutation: CreateCorrectedEmail,
        variables: {
          input: {
            taskId: id,
            email: newEmail
          }
        },
        refetchQueries: [
          {
            query: CurrentClaim,
            variables: {
              id: claimId
            }
          }
        ]
      })
      .then(() => {
        this.setState({ loading: false });
        onTaskComplete();
      })
      .catch(() => this.setState({ loading: false }));
  };

  render = () => {
    const { task, claim, loading } = this.props;
    const { newEmail } = this.state;
    const passengerEmail = _.get(
      claim,
      'passengerTicket.passengerEmail',
      ''
    );

    return (
      <TaskView
        task={task}
        claim={claim}
        newEmail={newEmail === undefined ? passengerEmail : newEmail}
        loading={loading || this.state.loading}
        onEmailChange={this.handleEmailChange}
        onTaskUpdate={this.handleTaskUpdate}
      />
    );
  };
}

export default compose(
  withApollo,
  withClaimQuery
)(ContactPaxRegardingInvalidEmailTask);



// WEBPACK FOOTER //
// ./src/component/tasks/ContactPaxRegardingInvalidEmailTask/index.js